import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import huElements from "../locales/hu/elements.json";

export const DEFAULT_LOCALE = "hu";

// Namespace-ek külön tartva: az "elements" a Unity element-nevekre,
// a "common" (későbbi) az általános UI-stringekre.
export const resources = {
    hu: {
        elements: huElements,
    },
} as const;

// =============== OTHER USAGE LATER IN UI COMPONENTS
// useLocale / useLanguage
// in component: t('translation_key', localeDomain)


i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: DEFAULT_LOCALE,
        fallbackLng: DEFAULT_LOCALE,
        ns: ["elements"],
        defaultNS: "elements",
        // A magyar fordítások már escape-mentesek, és Reactben amúgy is escape-el a DOM:
        interpolation: {escapeValue: false},
        // Nincs nyelvváltó UI még → nem kell detector/backend.
    }).then(r => r);

export default i18n;